<template>
    <oc-button-input type="submit" v-bind="$attrs" v-on="$listeners">
        <slot>{{text}}</slot>
    </oc-button-input>
</template>

<script>
import BaseInputComponent from '@/helpers/BaseInputComponent'

export default {
    name: 'oc-submit-button-input',
    extends: BaseInputComponent,
    props: {
        text: String
    }
}
</script>
